export enum ActionConstants {
	SET_DEPOSITS = 'set_deposits',
	ADD_DEPOSIT = 'add_deposits',
}
